import Vue from 'vue'
import Router from 'vue-router'

import LoginView from '@/views/LoginView.vue'
import MainView from '@/views/MainView.vue'
import DashboardView from '@/views/DashboardView.vue'
import DictionaryListView from '@/views/DictionaryListView.vue'
import LanDataListView from '@/views/LanDataListView.vue'
import StoreInfoView from '@/views/StoreInfoView.vue'
import StorePauseView from '@/views/StorePauseView.vue'
import CategoryListForStoreView from '@/views/CategoryListForStoreView.vue'
import TableMngListForStoreView from '@/views/TableMngListForStoreView.vue'
import StuffListForStoreView from '@/views/StuffListForStoreView.vue'
import SMenuOptTpListForStoreView from '@/views/SMenuOptTpListForStoreView.vue'
import SMenuOptListForStoreView from '@/views/SMenuOptListForStoreView.vue'
import SMenuOptGroupForStoreView from '@/views/SMenuOptGroupForStoreView.vue'

import DiscountListForStoreView from '@/views/DiscountListForStoreView.vue'
import MenuBoardView from '@/views/MenuBoardView.vue'
import SMenuListForStoreView from '@/views/SMenuListForStoreView.vue'
import DeliveryMenuOrphanView from '@/views/DeliveryMenuOrphanView.vue'
import DeliveryMenuDriftView from '@/views/DeliveryMenuDriftView.vue'
import DeliveryMenuMatrixView from '@/views/DeliveryMenuMatrixView.vue'
import DeliveryMenuShopMapView from '@/views/DeliveryMenuShopMapView.vue'
import DeliveryOptionMappingView from '@/views/DeliveryOptionMappingView.vue'
import DeliveryCapabilityView from '@/views/DeliveryCapabilityView.vue'
import OrderListView from '@/views/OrderListView.vue'
import OrderRefundPendingView from '@/views/OrderRefundPendingView.vue'
import EquipmentRequestListView from '@/views/EquipmentRequestListView.vue'
import SubscriptionListView from '@/views/SubscriptionListView.vue'
import StoreExternalCodeListForStoreView from '@/views/StoreExternalCodeListForStoreView.vue'
import MobilePosBannerListView from '@/views/MobilePosBannerListView.vue'
import StatisticsPayView from '@/views/StatisticsPayView.vue'
import StatisticsMenuView from '@/views/StatisticsMenuView.vue'
import StatisticsTimeView from '@/views/StatisticsTimeView.vue'
import IntegratedSalesView from '@/views/IntegratedSalesView.vue'
import IntegratedSalesComparisonView from '@/views/IntegratedSalesComparisonView.vue'
import IntegratedSettlementDetailView from '@/views/IntegratedSettlementDetailView.vue'
import IntegratedSettlementOpsView from '@/views/IntegratedSettlementOpsView.vue'
import NotiListForStoreView from '@/views/NotiListForStoreView.vue'

import AccountListView from '@/views/AccountListView.vue'
import LanListView from '@/views/LanListView.vue'
import TermsListView from '@/views/TermsListView.vue'
import CustListView from '@/views/CustListView.vue'
import PlaceListView from '@/views/PlaceListView.vue'
import CallpopOrgView from '@/views/callpop/CallpopOrgView.vue'
import CallpopStoreListView from '@/views/callpop/CallpopStoreListView.vue'
import CallpopStoreRegisterView from '@/views/callpop/CallpopStoreRegisterView.vue'
import CallpopHistoryView from '@/views/callpop/CallpopHistoryView.vue'
import AiInfoListView from '@/views/AiInfoListView.vue'
import AuthListView from '@/views/AuthListView.vue'
import NotiListView from '@/views/NotiListView.vue'
import UserListView from '@/views/UserListView.vue'
import MenuListView from '@/views/MenuListView.vue'
import AppUserListView from '@/views/AppUserListView.vue'
import CustTreeView from '@/views/CustTreeView.vue'
import ActionListView from '@/views/ActionListView.vue'
import BannerListView from '@/views/BannerListView.vue'
import DeliveryListView from '@/views/DeliveryListView.vue'
import CodeListView from '@/views/CodeListView.vue'
import PushListView from '@/views/PushListView.vue'
import OptionListView from '@/views/OptionListView.vue'
import HistoryListView from '@/views/HistoryListView.vue'
import InquiryListView from '@/views/InquiryListView.vue'
import EventListView from '@/views/EventListView.vue'
import PasswordListView from '@/views/PasswordListView.vue'

import CustInfoView from '@/views/CustInfoView.vue'
import NotiListForCustView from '@/views/NotiListForCustView.vue'
import StoreExternalCodeListView from '@/views/StoreExternalCodeListView.vue'
import StatisticsPayForCustView from '@/views/StatisticsPayForCustView.vue'
import StoreListView from '@/views/StoreListView.vue'
import UserListForCustView from '@/views/UserListForCustView.vue'
import TableMngListView from '@/views/TableMngListView.vue'
import CategoryListView from '@/views/CategoryListView.vue'
import SMenuOptTpListView from '@/views/SMenuOptTpListView.vue'
import SMenuOptListView from '@/views/SMenuOptListView.vue'
import SMenuListView from '@/views/SMenuListView.vue'

import UserCustView from '@/views/UserCustView.vue'
import UserStoreView from '@/views/UserStoreView.vue'
import AccountInfoView from '@/views/AccountInfoView.vue'

import store from '@/stores'
import OrderDeliveryListForStoreView from '@/views/OrderDeliveryListForStoreView.vue'
import TelInfoView from '@/views/TelInfoView.vue'
import AccessDeniedView from '@/views/AccessDeniedView.vue'
import { accountInfoPathOf } from '@/utils/adminRole'
import { CALLPOP_ACTION, CALLPOP_PATH } from '@/utils/callpopOrg'
import { ROUTE_LAYOUT } from '@/utils/routeLayout'
import { ACCESS_DENIED_PATH, refusedRouteTarget, routeAccess } from '@/utils/routeAccess'
import { resolvesAsRefusal } from '@/utils/sessionMenu'
import { NAVER_PLACE_LINK_PATH } from '@/utils/partnerLink'
import { STORE_PAUSE_ACTION, STORE_PAUSE_PATH } from '@/utils/storePause'
import { ORDER_LIST_ACTION, ORDER_REFUND_PENDING_PATH } from '@/utils/orderRefund'
import { EQUIPMENT_REQUEST_ACTION, EQUIPMENT_REQUEST_PATH } from '@/utils/equipmentRequest'
import { SUBSCRIPTION_ADMIN_ACTION, SUBSCRIPTION_ADMIN_PATH } from '@/utils/subscriptionAdmin'
import { DISCOUNT_PICKED_PATH, DISCOUNT_STORE_SOURCE, discountStoreSource } from '@/utils/discountStoreSource'
import { CUSTOMER_IMPORT_ACTION, CUSTOMER_IMPORT_PATH } from '@/utils/customerImport'
import { TEL_INFO_LIST_PATH } from '@/utils/telInfo'
import { CALLPOP_JOIN_PATH } from '@/utils/ownerSignup'
import { STORE_APPLICATION_ACTION, STORE_APPLICATION_PATH } from '@/utils/storeApplication'

Vue.use(Router)

const AiChatView = () => import('@/views/AiChatView.vue')
// 고객 가져오기 — 사장님·대리점이 가끔 여는 화면이라 본 번들에 섞지 않는다
const CustomerImportView = () => import('@/views/CustomerImportView.vue')

/** 통합 매출 조회의 액션 — `GET /api/statistics/integrated-sales/**` 리소스(서버 `sys_action`) */
const INTEGRATED_SALES_VIEW_ACTION = 'IntegratedSalesView'
// POS 임베드 화면 — 관리자 포털 본 번들에 섞지 않는다(그 화면을 여는 것은 POS 뿐이다)
const PosDeliverySoldoutView = () => import('@/views/pos/PosDeliverySoldoutView.vue')
const NaverPlaceLinkView = () => import('@/views/pos/NaverPlaceLinkView.vue')
// 콜팝 웹 가입의 공개 화면 둘 — 관리자 포털 본 번들에 섞지 않는다(휴대폰에서도 연다)
const CallpopJoinView = () => import('@/views/CallpopJoinView.vue')
const DocUploadView = () => import('@/views/DocUploadView.vue')
const StoreApplicationMineView = () => import('@/views/StoreApplicationMineView.vue')
const CallpopApplicationListView = () => import('@/views/callpop/CallpopApplicationListView.vue')

/**
 * 로그인 없이 여는 화면의 meta — 셸 없는 레이아웃 · 세션 메뉴와 무관(`menuFree` — 다른 계정으로 로그인해 둔 브라우저에서도 연다) · 공개
 * (`public` — `App.vue` 의 로그인 이동 예외, `utils/routeAccess.isPublicRoute`)
 */
const PUBLIC_ROUTE_META = Object.freeze({ layout: ROUTE_LAYOUT.CLEAR, menuFree: true, public: true })

const router = new Router({
  mode: 'history',
  routes: [
    // `meta.menuFree` — 세션 메뉴와 무관한 화면이다(라우터 가드 `utils/routeAccess`). 로그인·역할 홈 분기·권한 없음 안내
    {
      meta: {
        layout: 'clear',
        menuFree: true,
      },
      path: '/login',
      component: LoginView,
    },
    {
      path: '/',
      component: MainView,
      meta: { menuFree: true },
    },
    {
      path: ACCESS_DENIED_PATH,
      component: AccessDeniedView,
      meta: { menuFree: true },
    },
    // 콜팝 가맹점 웹 가입(계획 callpop-web-signup §11.9) — 공개 화면 둘. 가입 3단계와 휴대폰 서류 올리기(QR·알림톡 버튼이 여는 7일 링크)
    {
      path: CALLPOP_JOIN_PATH,
      component: CallpopJoinView,
      meta: PUBLIC_ROUTE_META,
    },
    {
      path: STORE_APPLICATION_PATH.UPLOAD,
      component: DocUploadView,
      meta: PUBLIC_ROUTE_META,
    },
    // 사장님 서류(§11.9) — 사이드 메뉴 행이 없다. 가입 직후 자동으로 오고, 로그인 뒤 안 끝난 신청이 있으면 안내(`LoginView`)에서 온다.
    // 게이트는 이 화면이 반드시 부르는 조회(`GET …/mine`)의 액션이다
    {
      path: STORE_APPLICATION_PATH.MINE,
      component: StoreApplicationMineView,
      meta: { requiredAction: STORE_APPLICATION_ACTION.MINE },
    },
    {
      path: '/v/system/dashboard/show',
      component: DashboardView,
    },
    {
      path: '/v/system/dictionary/list',
      component: DictionaryListView,
    },
    {
      path: '/v/system/lanData/list',
      component: LanDataListView,
    },
    {
      path: '/v/business/store/info',
      component: StoreInfoView,
    },
    // 주문 접수 임시중단(R-E1) — 사이드 메뉴 행은 appserver SQL 033 §3 이 이 경로로 넣는다(바꾸면 그 SQL 도).
    // 게이트는 역할이 아니라 걸기 액션이다 — 관리점·운영사(R-E2)는 서버가 액션을 더하는 것만으로 들어온다
    {
      path: STORE_PAUSE_PATH,
      component: StorePauseView,
      meta: { requiredAction: STORE_PAUSE_ACTION.PAUSE },
    },
    {
      path: '/v/business/category/list_for_store',
      component: CategoryListForStoreView,
    },
    {
      path: '/v/business/tableMng/list_for_store',
      component: TableMngListForStoreView,
    },
    {
      path: '/v/business/stuff/list_for_store',
      component: StuffListForStoreView,
    },
    {
      path: '/v/business/smenuOptTp/list_for_store',
      component: SMenuOptTpListForStoreView,
    },
    {
      path: '/v/business/smenuOpt/list_for_store',
      component: SMenuOptListForStoreView,
    },
    {
      path: '/v/business/smenuOptGroup/list_for_store',
      component: SMenuOptGroupForStoreView,
    },
    {
      path: '/v/business/discount/list_for_store',
      component: DiscountListForStoreView,
    },
    // 사업장 관리자·관리점·운영사의 「할인 관리」 — **같은 컴포넌트**를 고른 매장 원천으로 연다(R-E2). 메뉴 행만 있고
    // 라우트가 없던 자리다. 원천의 차이(경로·액션·질의·등록 본문)는 `utils/discountStoreSource` 한 곳이 갖는다
    //
    // 메뉴 행(`sys_menu`)은 꺼져 있을 수 있고(dev `use_yn = N`) 관리점 대행 바로가기가 이 경로를 연다 — 그래서 메뉴가 아니라
    // 이 화면이 반드시 부르는 조회의 액션(고른 매장 원천의 `search`)으로 막는다. 그 액션이 없는 내부 admin 이 주소로 열면
    // 첫 조회(`/store/combo` 등)를 부르기 전에 안내로 간다(R-K2 J1)
    {
      path: DISCOUNT_PICKED_PATH,
      component: DiscountListForStoreView,
      props: { storeSource: DISCOUNT_STORE_SOURCE.PICKED },
      meta: { requiredAction: discountStoreSource(DISCOUNT_STORE_SOURCE.PICKED).actions.search },
    },
    {
      path: '/v/business/smenu/list_for_store',
      component: SMenuListForStoreView,
    },
    {
      path: '/v/business/menuBoard/list_for_store',
      component: MenuBoardView,
    },
    // 배달 3사 메뉴 동기화 — 사장님 화면(①②③④)은 DeliveryMenuView 게이트를 공유한다.
    // ①은 별도 라우트가 아니라 메뉴 목록 화면의 chip 열이다.
    {
      path: '/v/business/delivery-menu/option-mappings',
      component: DeliveryOptionMappingView,
      meta: { requiredAction: 'DeliveryMenuView', fallbackPath: '/v/business/smenu/list_for_store' },
    },
    {
      path: '/v/business/delivery-menu/orphans',
      component: DeliveryMenuOrphanView,
      meta: { requiredAction: 'DeliveryMenuView', fallbackPath: '/v/business/smenu/list_for_store' },
    },
    {
      path: '/v/business/delivery-menu/drifts',
      component: DeliveryMenuDriftView,
      meta: { requiredAction: 'DeliveryMenuView', fallbackPath: '/v/business/smenu/list_for_store' },
    },
    {
      path: '/v/business/delivery-menu/matrix',
      component: DeliveryMenuMatrixView,
      meta: { requiredAction: 'DeliveryMenuView', fallbackPath: '/v/business/smenu/list_for_store' },
    },
    // 배달 샵 ↔ 매장 매핑 — 같은 게이트다. 인가도 같은 와일드카드(`/api/delivery-menu/**`)를 타므로
    // `sys_resources` 에 새 API 행이 필요 없다 (설계 §8.2 · sql/db_changes_2026-08-07_delivery-shop-map-auth.sql).
    {
      path: '/v/business/delivery-menu/shop-map',
      component: DeliveryMenuShopMapView,
      meta: { requiredAction: 'DeliveryMenuView', fallbackPath: '/v/business/smenu/list_for_store' },
    },
    // 품절 관리의 **어드민 진입** (2026-09-05 D-S1) — 아래 POS 임베드 라우트와 **같은 컴포넌트**다(사본 없음).
    // `/v/business/` 접두라 `isEmbedPath`·`isEmbedRoute` 가 자동으로 false 이고, 그래서 레이아웃 meta 를 주지 않는다 —
    // 앱 셸이 붙고 화면이 매장 바를 그린다. 사이드 메뉴는 임베드와 달리 고정 URL 이라 `?storeCd=` 를 실을 수 없어,
    // 매장 축은 화면 안의 매장 바(세션 매장이 기본)가 URL 쿼리로 옮긴다.
    {
      path: '/v/business/delivery-menu/soldout',
      component: PosDeliverySoldoutView,
      meta: { requiredAction: 'DeliveryMenuView' },
    },
    // ⑤ 는 운영자 도구다 — 경로 접두사(/api/admin/**)도 권한(admin·mng)도 달라 사장님 내비게이션과
    // 같은 트리에 두지 않는다 (§9.2 · §14 "매장 계정이 capability 를 등록할 수 없다").
    {
      path: '/v/system/delivery-capability',
      component: DeliveryCapabilityView,
      meta: { requiredAction: 'DeliveryCapabilityAdd', fallbackPath: '/' },
    },
    {
      path: '/v/business/order/list',
      component: OrderListView,
    },
    // 내부 운영자용 환불 실패 목록(매장 횡단, R-L WP2 후속) — 사이드 메뉴 행이 없다. 진입은 사업장 조회 화면의 버튼이고, 가드는
    // 그 화면이 반드시 부르는 `GET /order` 의 액션으로 연다(admin·mng 는 서버 SQL 043 이 준다)
    {
      path: ORDER_REFUND_PENDING_PATH,
      component: OrderRefundPendingView,
      meta: { requiredAction: ORDER_LIST_ACTION },
    },
    // 장비 설치 신청(설계안 2판 §10.2) — 사이드 메뉴 행 「사업장 관리 > 장비 신청」은 appserver SQL 081 이 이 경로로 넣는다(바꾸면
    // 그 SQL 도). 게이트는 이 화면이 반드시 부르는 목록 조회의 액션이다 — 화면이 SQL 보다 먼저 나가도 메뉴·액션 없는 세션에는 열리지 않는다
    {
      path: EQUIPMENT_REQUEST_PATH,
      component: EquipmentRequestListView,
      meta: { requiredAction: EQUIPMENT_REQUEST_ACTION.SEARCH },
    },
    // 요금·결제(설계안 2판 §10.1) — 사이드 메뉴 행 「사업장 관리 > 요금·결제」는 appserver SQL 082 가 이 경로로 넣는다(바꾸면 그 SQL 도).
    // 게이트는 첫 탭(구독 목록) 조회의 액션이다
    {
      path: SUBSCRIPTION_ADMIN_PATH,
      component: SubscriptionListView,
      meta: { requiredAction: SUBSCRIPTION_ADMIN_ACTION.SEARCH },
    },
    {
      path: '/v/business/storeexternalcode/list_for_store',
      component: StoreExternalCodeListForStoreView,
    },
    {
      path: '/v/business/mobile-pos-banner/list',
      component: MobilePosBannerListView,
    },
    {
      path: '/v/business/statistics/pay',
      component: StatisticsPayView,
    },
    {
      path: '/v/business/statistics/menu',
      component: StatisticsMenuView,
    },
    {
      path: '/v/business/statistics/time',
      component: StatisticsTimeView,
    },
    // 통합 매출 세 화면은 첫 조회(`GET /api/statistics/integrated-sales/**`)의 액션으로 연다 — 메뉴 행은 사업장·매장
    // 관리자에게만 있지만 내부 admin·mng 도 그 액션을 갖고 운영 화면에서 대시보드로 오간다(서버 `sys_action`)
    {
      path: '/v/business/integrated-sales',
      component: IntegratedSalesView,
      meta: { requiredAction: INTEGRATED_SALES_VIEW_ACTION },
    },
    {
      path: '/v/business/integrated-sales/detail',
      component: IntegratedSettlementDetailView,
      meta: { requiredAction: INTEGRATED_SALES_VIEW_ACTION },
    },
    {
      path: '/v/business/integrated-sales/comparison',
      component: IntegratedSalesComparisonView,
      meta: { requiredAction: INTEGRATED_SALES_VIEW_ACTION },
    },
    {
      path: '/v/business/integrated-sales/ops',
      component: IntegratedSettlementOpsView,
      meta: { requiredAction: 'IntegratedSalesAdmin', fallbackPath: '/v/business/integrated-sales' },
    },
    {
      path: '/v/business/noti/list_for_store',
      component: NotiListForStoreView,
    },

    {
      path: '/v/system/account/list',
      component: AccountListView,
    },
    {
      path: '/v/system/lan/list',
      component: LanListView,
    },
    {
      path: '/v/system/terms/list',
      component: TermsListView,
    },
    {
      path: '/v/business/cust/list',
      component: CustListView,
    },
    {
      path: '/v/business/place/list',
      component: PlaceListView,
    },
    // 콜팝 운영사·관리점 화면 4종 (B7-b). 사이드 메뉴는 **DB 가 준다**(`GET /mainMenu`) — 라우트를 더하면
    // appserver 의 nav SQL 도 같이 고친다(보고서의 nav 표). `meta.requiredAction` 은 **그 화면이 반드시
    // 부르는 조회**의 액션이다: 없으면 그 첫 호출이 401 이고 이 앱의 401·403 은 세션을 끝낸다.
    //
    // `fallbackPath` 는 **갈 곳이 있어야 한다**(정하지 않으면 권한 없음 안내다). `/` 는 `MainView` 가 역할별 홈으로
    // 되돌리는데 운영사·관리점의 홈이 바로 이 라우트들이라 빈 화면을 오간다. 그렇다고 한 경로를 못박으면 그것이
    // 자기 것이 아닌 역할에서 403 로그아웃이 된다 — 보낼 곳은 **역할이 정한다**(`utils/routeAccess` 의 [refusedRouteTarget]).
    {
      path: CALLPOP_PATH.ORG,
      component: CallpopOrgView,
      meta: { requiredAction: CALLPOP_ACTION.AGENCY_SEARCH, fallbackPath: accountInfoPathOf },
    },
    {
      path: CALLPOP_PATH.STORES,
      component: CallpopStoreListView,
      meta: { requiredAction: CALLPOP_ACTION.STORE_SEARCH, fallbackPath: accountInfoPathOf },
    },
    {
      path: CALLPOP_PATH.STORE_NEW,
      component: CallpopStoreRegisterView,
      meta: { requiredAction: CALLPOP_ACTION.AGENCY_STORE_ADD, fallbackPath: CALLPOP_PATH.STORES },
    },
    {
      path: CALLPOP_PATH.HISTORY,
      component: CallpopHistoryView,
      meta: { requiredAction: CALLPOP_ACTION.ORG_HISTORY_GET, fallbackPath: accountInfoPathOf },
    },
    // 「콜팝 가입신청」(§11.9) — 사이드 메뉴 행은 appserver 메뉴 SQL(관리 웹 배포 뒤)이 이 경로로 넣는다. 게이트는 목록 조회의 액션이다 —
    // 내부와 콜팝 역할(콜팝 관리자·운영사·관리점)이 같은 화면을 열고, 역할마다 보이는 칸은 서버 응답이 정한다
    {
      path: CALLPOP_PATH.APPLICATIONS,
      component: CallpopApplicationListView,
      meta: { requiredAction: STORE_APPLICATION_ACTION.SEARCH, fallbackPath: accountInfoPathOf },
    },
    {
      path: TEL_INFO_LIST_PATH,
      component: TelInfoView,
    },
    // 고객 가져오기(전화주문 W1) — 사이드 메뉴 행 「고객 가져오기」는 appserver SQL 057 이 이 경로로 넣는다(바꾸면 그 SQL 도).
    // 게이트는 메뉴가 아니라 이 화면이 반드시 부르는 조회(가져온 기록 `GET /telInfo/import`)의 액션이다 — 메뉴 행이 없어도(POS
    // 환경설정의 매직링크 `page`) 액션으로 판정되고, 057 전에는 권한 없음 안내(로그아웃 아님)다. **POS 릴리스보다 이 라우트가 먼저
    // 배포돼야 한다** — 등록 전에는 매직링크 `page` 가 `safeRedirectPage` 에서 `/` 로 떨어진다.
    {
      path: CUSTOMER_IMPORT_PATH,
      component: CustomerImportView,
      meta: { requiredAction: CUSTOMER_IMPORT_ACTION.LIST },
    },
    {
      path: '/v/system/aiInfo/list',
      component: AiInfoListView,
    },
    // AI 챗은 메뉴 행이 없고 appserver 를 부르지 않는다(오케스트레이터만 — 403 로그아웃이 없다). 종전처럼 주소로 연다
    {
      path: '/v/system/aiChat/list',
      component: AiChatView,
      meta: { menuFree: true },
    },
    {
      path: '/v/system/auth/list',
      component: AuthListView,
    },
    {
      path: '/v/system/noti/list',
      component: NotiListView,
    },
    {
      path: '/v/business/user/list',
      component: UserListView,
    },
    {
      path: '/v/system/menu/list',
      component: MenuListView,
    },
    {
      path: '/v/business/appUser/list',
      component: AppUserListView,
    },
    {
      path: '/v/business/cust/tree',
      component: CustTreeView,
    },
    {
      path: '/v/system/action/list',
      component: ActionListView,
    },
    {
      path: '/v/system/banner/list',
      component: BannerListView,
    },
    {
      path: '/v/business/delivery/list',
      component: DeliveryListView,
    },
    {
      path: '/v/system/code/list',
      component: CodeListView,
    },
    {
      path: '/v/business/push/list',
      component: PushListView,
    },
    {
      path: '/v/system/option/list',
      component: OptionListView,
    },
    {
      path: '/v/system/history/list',
      component: HistoryListView,
    },
    {
      path: '/v/business/inquiry/list',
      component: InquiryListView,
    },
    {
      path: '/v/business/event/list',
      component: EventListView,
    },
    {
      path: '/v/system/password/list',
      component: PasswordListView,
    },
    {
      path: '/v/business/cust/info',
      component: CustInfoView,
    },
    {
      path: '/v/business/noti/list_for_cust',
      component: NotiListForCustView,
    },
    {
      path: '/v/business/storeexternalcode/list',
      component: StoreExternalCodeListView,
    },
    // 사업장 통계 — 화면의 첫 조회 `GET /cust/statistics/pay` 의 액션으로 막는다(R-D2 ⓔ). SQL 036 뒤 이 액션은
    // custMng·custMngTemp 전용이라 storeMng 가 URL 로 들어오면 그 첫 조회가 403(= 로그아웃)이 된다. 같은 화면의
    // smenu·tree 조회는 탭·버튼이 부르는 곁가지이고 사업장 통계 라우트는 이 하나뿐이다
    {
      path: '/v/business/statistics/pay_for_cust',
      component: StatisticsPayForCustView,
      meta: { requiredAction: 'StatisticsPaySearchForCust' },
    },
    {
      path: '/v/business/store/list',
      component: StoreListView,
    },
    {
      path: '/v/business/user/list_for_cust',
      component: UserListForCustView,
    },
    {
      path: '/v/business/tableMng/list',
      component: TableMngListView,
    },
    {
      path: '/v/business/category/list',
      component: CategoryListView,
    },
    {
      path: '/v/business/smenuOptTp/list',
      component: SMenuOptTpListView,
    },
    {
      path: '/v/business/smenuOpt/list',
      component: SMenuOptListView,
    },
    {
      path: '/v/business/smenu/list',
      component: SMenuListView,
    },
    {
      path: '/v/business/user/cust',
      component: UserCustView,
    },
    {
      path: '/v/business/user/store',
      component: UserStoreView,
    },
    {
      path: '/v/system/account/info',
      component: AccountInfoView,
    },
    {
      path: '/v/business/order-delivery/list_for_store',
      component: OrderDeliveryListForStoreView,
    },
    // POS 임베드 — 배달 메뉴·옵션 품절 관리 (결정 브리프 2026-09-03 · D1). 사이드 메뉴에 등록하지 않는다(SQL 없음) —
    // pos2-lite·ordern_pos2 가 매직링크 `page` 로 `?storeCd=` 와 함께 연다. 권한·매장 검증 실패는 리다이렉트가 아니라
    // **페이지 안 안내**다(아래 beforeEach 가 임베드 라우트를 건너뛰고, 화면이 같은 meta 를 읽어 답한다).
    {
      path: '/v/pos/delivery-soldout',
      component: PosDeliverySoldoutView,
      meta: { layout: ROUTE_LAYOUT.EMBED, requiredAction: 'DeliveryMenuView' },
    },
    // POS 임베드 — 네이버 플레이스 연동 위저드 (네이버 계획 §2.1 C). 진입은 셋이다: 외부 채널 패널의 「연동하기」
    // (새 탭) · POS 2종의 매직링크 `page` · 점주 모바일 로그인 뒤 이동. **POS 릴리스보다 이 라우트가 먼저 배포돼야
    // 한다** — 등록 전에는 매직링크 `page` 가 `safeRedirectPage` 에서 `/` 로 떨어진다.
    {
      path: NAVER_PLACE_LINK_PATH,
      component: NaverPlaceLinkView,
      meta: { layout: ROUTE_LAYOUT.EMBED, requiredAction: 'NaverPlaceLinkApply' },
    },
  ],
})

/**
 * 라우트 상태는 **확정된 뒤에만** 커밋한다 (12R P10 · 원장 `ROUTE-STATE-BEFORE-NAV-SETTLES`).
 *
 * `beforeEach` 에서 커밋하면 지연 청크 실패로 내비게이션이 중단됐을 때 저장 라우트(임베드)와 실제 라우트(일반)가
 * 갈린다 — 그 사이 나간 요청의 403 이 임베드 창의 것으로 판정돼 로그아웃을 건너뛰거나 그 반대가 된다. `afterEach` 는
 * 내비게이션이 확정된 뒤에만 불리고, `plugins/http` 는 요청마다 이 값을 스냅샷으로 찍어 판정한다(`policy.js`).
 */
router.afterEach((to) => {
  store.commit('SET_ROUTE', to)
})

/**
 * **라우터 가드 — 이 세션이 이 화면을 여는가** (판정은 `utils/routeAccess` 한 곳, R-L P3-8 · R-K5 O-5).
 *
 * 이 앱의 403 은 세션을 끝낸다. 자기 메뉴·액션에 없는 화면을 주소로 열면 그 화면의 첫 조회가 403 → 강제 로그아웃이었다.
 * 그래서 **화면 본문을 만들기 전에** 세션 메뉴·액션으로 답하고, 거절된 화면은 요청 없이 권한 없음 안내(또는 그 라우트가 정한
 * `fallbackPath`)로 바꿔 끼운다(replace).
 *
 * **가드는 메뉴를 기다리지 않는다**(R-L 리뷰 M-1). 세션 메뉴를 아직 모르면(`needsMenu`) 이동을 통과시키고 — 셸이 먼저 그려진다 —
 * 화면 본문만 보류한다(`App.vue` 가 `currentRouteAccess.needsMenu` 동안 `<router-view>` 를 만들지 않는다). 메뉴는 셸의 SideNav
 * 와 보류된 화면이 청하고 `stores/menu` 의 액션 하나가 한 번 읽는다(가벼운 조회 — 짧은 타임아웃·토스트 없음). 메뉴가 오면 보류된
 * 화면의 답이 정해진다: 열리면 본문이 그려지고, 거절이면 아래 감시자가 안내로 바꿔 끼운다. 못 읽었으면 증거가 없어 막지
 * 않는다(종전 동작) — 그 실패는 세션 동안 기억돼 다음 이동이 다시 기다리지 않는다.
 *
 * 임베드 라우트(POS 안의 창)는 리다이렉트하지 않는다 — 그 화면이 같은 `meta.requiredAction` 을 읽어 페이지 안에서 안내한다.
 */
router.beforeEach((to, from, next) => {
  const session = store.getters.routeSession
  const access = routeAccess(to, session)

  if (access.allowed || access.needsMenu) {
    next()
    return
  }

  next(refusedRouteTarget(to, session.authId))
})

/**
 * **보류된 화면이 거절로 풀리면 안내로 바꿔 끼운다** — 판정은 `utils/sessionMenu.resolvesAsRefusal`(순수). 확정된 라우트의 답
 * (`currentRouteAccess`)이 「메뉴를 기다린다」에서 거절로 바뀐 순간에만 움직인다. 그 화면의 본문은 한 번도 만들어지지 않았다.
 */
store.watch(
  (state, getters) => getters.currentRouteAccess,
  (access, previous) => {
    const route = store.state.route
    if (!route || !resolvesAsRefusal(previous, access)) return

    router.replace(refusedRouteTarget(route, store.getters.routeSession.authId)).catch(() => {})
  }
)

export default router
